import { TFunction } from 'i18next';
import { MyAdsPromotionServicesByKind } from './MyAdsPromotionFlow.types';
import { AdKind } from '@/api/types/common.types';
import { AdService } from '@/api/types/services.types';
import {
  CreatePaymentResponse,
  PaymentMethod,
} from '@/api/types/payments.types';
import { MyAdPromotionDetails } from '@/features/Profile/sections/MyAds/api';
import { getPriceWithDiscount } from '@/components/Ad/Promotions/PromotionFlow.helpers';
import { getLessPrice } from '@/components/Ad/Promotions/Promotions.helpers';
import { mapPaymentDataToUrl } from '@/views/Wallet/Finish.helpers';
import { formatDate } from '@/utils/helpers';

export function getMyAdsPromotionServices(
  adDetails?: MyAdPromotionDetails | null
): MyAdsPromotionServicesByKind {
  return {
    [AdKind.Bumped]: adDetails?.bumpServices,
    [AdKind.Premium]: adDetails?.featuredServices,
    [AdKind.Vipped]: adDetails?.vipServices,
  };
}

export function getMyAdsPromotionPaymentUrl({
  data,
  adDetails,
  service,
  type,
  walletDiscount,
  applyWalletDiscount,
  payment,
}: {
  data: CreatePaymentResponse;
  adDetails?: MyAdPromotionDetails | null;
  service: AdService | null;
  type: AdKind | null;
  walletDiscount: number;
  applyWalletDiscount: boolean;
  payment: PaymentMethod;
}) {
  if (
    !adDetails ||
    !service ||
    !type ||
    !data.createPayment.entity.paymentLegacyId ||
    !data.createPayment.entity.paymentDate
  ) {
    return '';
  }

  return mapPaymentDataToUrl({
    id: data.createPayment.entity.paymentLegacyId,
    price: getPriceWithDiscount(
      getLessPrice(service),
      applyWalletDiscount,
      walletDiscount
    ).toString(),
    date: data.createPayment.entity.paymentDate,
    adId: adDetails.legacyResourceId.toString(),
    serviceType: type,
    period: service.period.toString(),
    paymentMethod: payment,
  });
}

export function getMyAdsPromotionPaidUntilDate({
  adDetails,
  type,
  t,
}: {
  adDetails?: MyAdPromotionDetails | null;
  type: AdKind | null;
  t: TFunction;
}) {
  if (!adDetails || !type || type === AdKind.Bumped) return null;

  const untilDate =
    type === AdKind.Vipped ? adDetails.vippedUntil : adDetails.featuredUntil;

  return untilDate
    ? t('pages.ad.paid_until', {
        date: formatDate(String(untilDate), 'dd MMMM yyyy, HH:mm'),
      })
    : null;
}
